/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimeDate } from './TimeDate';
import {
    TimeDateFromJSON,
    TimeDateFromJSONTyped,
    TimeDateToJSON,
    TimeDateToJSONTyped,
} from './TimeDate';

/**
 * 
 * @export
 * @interface CreateCaseNoteRequest
 */
export interface CreateCaseNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteRequest
     */
    type: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateCaseNoteRequest
     */
    date: Date | null;
    /**
     * 
     * @type {TimeDate}
     * @memberof CreateCaseNoteRequest
     */
    time: TimeDate | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteRequest
     */
    assignedCounselorId: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteRequest
     */
    location: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteRequest
     */
    content: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteRequest
     */
    result: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteRequest
     */
    appointmentStatus: string | null;
}

/**
 * Check if a given object implements the CreateCaseNoteRequest interface.
 */
export function instanceOfCreateCaseNoteRequest(value: object): value is CreateCaseNoteRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('assignedCounselorId' in value) || value['assignedCounselorId'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('appointmentStatus' in value) || value['appointmentStatus'] === undefined) return false;
    return true;
}

export function CreateCaseNoteRequestFromJSON(json: any): CreateCaseNoteRequest {
    return CreateCaseNoteRequestFromJSONTyped(json, false);
}

export function CreateCaseNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCaseNoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'date': (json['date'] == null ? null : new Date(json['date'])),
        'time': TimeDateFromJSON(json['time']),
        'assignedCounselorId': json['assignedCounselorId'],
        'location': json['location'],
        'content': json['content'],
        'result': json['result'],
        'appointmentStatus': json['appointmentStatus'],
    };
}

export function CreateCaseNoteRequestToJSON(json: any): CreateCaseNoteRequest {
    return CreateCaseNoteRequestToJSONTyped(json, false);
}

export function CreateCaseNoteRequestToJSONTyped(value?: CreateCaseNoteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'date': value['date'] == null ? value['date'] : `${value['date'].getFullYear()}-${String(value['date'].getMonth()+1).padStart(2,'0')}-${String(value['date'].getDate()).padStart(2,'0')}`,
        'time': TimeDateToJSON(value['time']),
        'assignedCounselorId': value['assignedCounselorId'],
        'location': value['location'],
        'content': value['content'],
        'result': value['result'],
        'appointmentStatus': value['appointmentStatus'],
    };
}

